<div class="modol_comp">
    <div class="modal-header pb-0 pt-0 d-flex">
        <button class="button-close" mat-button [mat-dialog-close]="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                    d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
            </svg>
        </button>
    </div>
    <div class="image-container mb-2">
        <img *ngIf="!data.includes('.pdf')" #contentToCapture id="image" [src]="data" alt="">
        <img *ngIf="data.includes('.pdf')" #contentToCapture id="image" src="assets/images/pdf.png" alt="">

    </div>
    <!-- <div class="button-container" *ngIf="!fromHelpSupport">

        <button *ngIf="!data.includes('.pdf')" id="downloadButton" type="button" class="btn pdf mx-1"
            (click)="downloadImage()">Download</button>
        <button *ngIf="!data.includes('.pdf')" type="button" class="btn pdf mx-1" (click)="downloadImageToPdf()">Print
            to PDF</button>
        <a *ngIf="data.includes('.pdf')" href="{{data}}">Download PDF</a>

    </div> -->
</div>